import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import Notifications from "../modules/Notifications/NotificationsPage";

export function NotificationsPage() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "notifications-page-title",
    defaultMessage: "Notifications center"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <Notifications/>;
}
